import styled from 'styled-components'

const HEADER_TABLE_GAP = '16px'
const TABLE_PAGINATION_GAP = '16px'

export const RankmiTableWrapper = styled.div`
  min-height: 0;
  overflow: visible;

  /* Anula márgenes negativos globales del Modal (.ant-modal-body .ant-row) */
  .rankmiTable-container .ant-row {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    align-items: center;
    overflow: visible;
  }

  /* Fila chip + buscador */
  .rankmiTable-container > .ant-row:first-of-type {
    align-items: center !important;
    justify-content: space-between !important;
    min-height: 40px;
    margin-bottom: ${HEADER_TABLE_GAP} !important;
    flex-wrap: nowrap;
    overflow: visible;
  }

  /* Oculta columnas vacías del header (sin chip ni buscador) */
  .rankmiTable-container
    > .ant-row:first-of-type
    > .ant-col:not(:has(.rankmiTable-rowsCount)):not(:has(.rankmiTable-searchInput)) {
    display: none !important;
  }

  .rankmiTable-container
    > .ant-row:first-of-type
    > .ant-col:has(.rankmiTable-rowsCount),
  .rankmiTable-container
    > .ant-row:first-of-type
    > .ant-col:has(.rankmiTable-searchInput) {
    width: auto !important;
    max-width: none !important;
    flex: 0 0 auto !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
    overflow: visible;
  }

  .rankmiTable-container
    > .ant-row:first-of-type
    > .ant-col:has(.rankmiTable-searchInput) {
    margin-left: auto !important;
  }

  .rankmiTable-container .ant-row .mb-2 {
    margin-bottom: 0 !important;
  }

  .rankmiTable-searchInput {
    width: 280px;
    max-width: 100%;
    flex-shrink: 0;
  }

  .ant-table-wrapper {
    margin-top: 0;
  }

  /* Evita min-height heredado de listados padre (gestión de cursos, etc.) */
  [class~='rankmiTable-table'],
  .ant-table-body,
  .ant-spin-container {
    min-height: 0 !important;
  }

  .rankmiTable-rowsCount {
    align-items: center;
    margin-bottom: 0;
  }

  .rankmiTable-rowsCount > .ant-tag {
    display: inline-flex;
    align-items: center;
    background-color: #f5f5f5;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    font-size: 14px;
    color: #363636;
    line-height: 1.4;
    padding: 4px 8px;

    svg {
      color: #363636;
      font-size: 12px;
      margin-right: 6px !important;
    }
  }

  /* Paginación */
  .rankmiTable-container > .ant-col:has(.rankmiTable-pagination) {
    margin-top: ${TABLE_PAGINATION_GAP} !important;
    margin-bottom: 0 !important;
    width: 100%;
  }

  .rankmiTable-pagination,
  .rankmiTable-container .rankmiTable-pagination {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  .rankmiTable-container {
    overflow: visible;
  }
`

export const ItemName = styled.span<{ $color?: string }>`
  padding: ${({ $color }) => ($color && $color !== 'unset' ? '4px' : '0')};
  border-radius: 8px;
  color: #363636;
  font-size: 12px;
  background-color: ${({ $color }) =>
    $color && $color !== 'unset' ? `${$color}26` : 'transparent'};
  border: ${({ $color }) =>
    $color && $color !== 'unset' ? `solid 1px ${$color}33` : 'none'};

  svg {
    color: #757575;
    margin-right: 4px;
  }
`

export const Alert = styled.div`
  font-size: 14px;
  padding: 8px 16px;
  color: #363636;
  background-color: #f5f5f5;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  margin-bottom: 16px;
  white-space: initial;

  svg {
    margin-top: 4px;
    margin-right: 12px;
    float: left;
  }
`

export const Description = styled.div`
  padding-left: 26px;
`
